module.exports = __webpack_public_path__ + "img/read-card-demo.25abdc34.png";